export enum PersonProtectionBenefitType {
  CIC = "CriticalIllnessCover",
  LIFE_COVER = "LifeCover",
  TERMINAL_ILLNESS = "TerminalIllness",
  INCOME_PROTECTION = "IncomeProtection",
  ACCIDENT_COVER = "AccidentCover",
  HOSPITAL_CASH = "HospitalCash",
  MEDICAL_EXPENSES = "MedicalExpenses",
  REHABILITATION = "Rehabilitation"
}
